
import { db } from "@/firebase";
import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";
import { collection, getDocs } from "firebase/firestore";

type Role = {
    permissions: string[];
}

type RolesState = Record<string, Role>

const initialState: RolesState = {}

export const fetchRole = createAsyncThunk(
    'roles/fetchRole',
    async () => {
        try {
          const collectionRef = collection(db, 'roles');
          const roles = await getDocs(collectionRef)
            .then((querySnapshot) => {
                return querySnapshot.docs.reduce((acc, doc) => {
                    return {...acc, [doc.id]: {...doc.data(), id: doc.id}};
                }, {})
            })
            return roles as Record<string, Role>;
        } catch (error) {
            console.error(error);
        }
    }
);

const rolesSlice = createSlice({
    name: "roles",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchRole.fulfilled, (state: any, action: PayloadAction<Record<string, Role> | undefined>) => {
            if (action.payload) {
                return action.payload;
            }
            return state
        })
    }
})

export const rolesSelector = (state: RolesState) => {
    return state.roles;
}



export default rolesSlice.reducer